// api/me.js
import { apiGet } from './http';

/**
 * GET /app/me/overview
 * 我的页聚合数据
 * - profile（等级 / 自己业绩 / 团队业绩 / 地址）
 * - area（小区业绩 / 升级进度）
 * - invite（直推数 / 返佣代数 / 邀请链接）
 *
 * @param {Object} config 可传 { silent: true }
 */
export function fetchMeOverview(config = {}) {
  return apiGet('/app/me/overview', {}, config);
}

/**
 * GET /app/me/referrals
 * 直推列表（分页）
 *
 * @param {Object} params
 *  - page: number (默认 1)
 *  - size: number (默认 20)
 * @param {Object} config 可传 { silent: true }
 */
export function fetchMeReferrals(params = {}, config = {}) {
  const {
    page = 1,
    size = 20,
  } = params || {};

  return apiGet(
    '/app/me/referrals',
    { page, size },
    config
  );
}

/**
 * GET /app/me/referrals/count
 * 直推统计
 * - directCount
 * - directActiveCount
 * - eligibleDepth
 *
 * @param {Object} config 可传 { silent: true }
 */
export function fetchMeReferralCount(config = {}) {
  return apiGet('/app/me/referrals/count', {}, config);
}


/**
 * GET /app/me/invite-bind-status
 * 是否已绑定邀请关系
 *
 * 返回：
 * true  = 已绑定
 * false = 未绑定
 *
 * @param {Object} config 可传 { silent: true }
 */
export function fetchInviteBindStatus(config = {}) {
  return apiGet('/app/me/invite-bind-status', {}, config);
}
